import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { articles } from "@/data/blog";
import Seo from "@/components/Seo";

const EASE = [0.22, 1, 0.36, 1];

export default function BlogList({ t, lang }) {
    return (
        <main className="relative z-10 mx-auto max-w-6xl px-5 sm:px-8 pt-36 pb-24 min-h-screen">
            <Seo title={t.blog.metaTitleList} description={t.blog.metaDescription} />
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-glacier">{t.blog.overline}</p>
            <h1 className="mt-4 font-display text-4xl sm:text-5xl font-medium tracking-tight text-ivory">
                {t.blog.title}
            </h1>
            <p className="mt-4 max-w-2xl text-base leading-relaxed text-fog">{t.blog.sub}</p>

            <div className="mt-14 grid gap-6 md:grid-cols-3">
                {articles.map((a, i) => {
                    const c = a[lang] || a.sk;
                    return (
                        <motion.a
                            key={a.slug}
                            href={`/blog/${a.slug}`}
                            data-testid={`blog-card-${a.slug}`}
                            initial={{ opacity: 0, y: 28 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6, delay: i * 0.1, ease: EASE }}
                            className="group flex flex-col rounded-lg border border-white/10 bg-coal p-7 transition-[border-color,transform] duration-500 hover:border-glacier/40 hover:-translate-y-1"
                        >
                            <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-fog">
                                {a.date} · {a.readMinutes} {t.blog.minRead}
                            </p>
                            <h2 className="mt-4 font-display text-xl font-medium leading-snug tracking-tight text-ivory">
                                {c.title}
                            </h2>
                            <p className="mt-3 flex-1 text-sm leading-relaxed text-fog">{c.excerpt}</p>
                            <span className="mt-6 inline-flex items-center gap-2 font-display text-xs font-semibold uppercase tracking-widest text-glacier transition-colors duration-300 group-hover:text-ivory">
                                {t.blog.readMore}
                                <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                            </span>
                        </motion.a>
                    );
                })}
            </div>
        </main>
    );
}
